import ReactDOM from "react-dom/client";
import React from "react";
import insertProductToBasketService from "../../basket/insert/InsertProductToBasketService";
import ProductDetailPageTypeConfig, { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import { Currency } from "../../../../js/common/CurrencyFormatter";
import elementService from "../../../../js/common/ElementService";
import ProductGalleryModal from "./ProductGalleryModal";

export default new class ProductModalGalleryService {
    private containerElement: HTMLDivElement | undefined;

    public init(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        if (pageTypeConfig.detailType !== "multi") {
            return;
        }

        this.initOpenModalGalleryButtons(pageTypeConfig, currency);
    }

    private initOpenModalGalleryButtons(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        for (const openModalGalleryButton of document.querySelectorAll<HTMLAnchorElement>(".js-open-modal-gallery")) {
            openModalGalleryButton.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                this.openModalGallery(openModalGalleryButton, pageTypeConfig, currency);
            });
        }
    }

    private openModalGallery(openModalGalleryButton: HTMLAnchorElement, pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        const productId = Number.parseInt(elementService.elementData(openModalGalleryButton, "productId"));
        const imageIndex = openModalGalleryButton.dataset.imageIndex === undefined
            ? 0
            : Number.parseInt(elementService.elementData(openModalGalleryButton, "imageIndex"));

        const containerElement = this.getContainerElement();
        const root = ReactDOM.createRoot(containerElement);

        const product = this.getProductForGallery(pageTypeConfig, productId);

        root.render(<ProductGalleryModal
            product={product}
            cheapestPrice={pageTypeConfig.cheapestPrice}
            startImageIndex={imageIndex}
            actionDiscountCode={pageTypeConfig.actionDiscountCode}
            megaClearanceSaleDiscountCode={pageTypeConfig.megaClearanceSaleDiscountCode}
            newProductsDiscountCode={pageTypeConfig.newProductsDiscountCode}
            onAfterClose={(): void => this.removeContainerElement()}
            onAddToBasket={(addedProductId: number): void => {
                root.unmount();
                this.removeContainerElement();
                insertProductToBasketService.showPopup(addedProductId);
            }}
            currency={currency}
        />);
    }

    private getProductForGallery(pageTypeConfig: ProductDetailPageTypeConfig, productId: number): ProductDetailInfo {
        const productForGallery = pageTypeConfig.products.find((product) => product.productId === productId);

        if (productForGallery === undefined) {
            throw new Error(`Product with ID ${productId} not found.`);
        }

        return productForGallery;
    }

    private getContainerElement(): HTMLDivElement {
        this.containerElement ??= document.createElement("div");

        return this.containerElement;
    }

    private removeContainerElement(): void {
        if (this.containerElement === undefined) {
            return;
        }

        this.containerElement.remove();
        this.containerElement = undefined;
    }
}();
